// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__TTpcr","img":"Card_img__gMRJu","title":"Card_title__1yJ7t","temp":"Card_temp__ICOfn","wei":"Card_wei__3ljEB"};